import {Flow} from "../../initializeFlows";
import {DonateHomeDonateComponent, DonateHomeDonateComponentStyle} from "../donate/DonateHomeDonateComponent";
import {styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";


class DonateHomeEditDonationComponentStyle extends DonateHomeDonateComponentStyle {
    @styleRuleInherit
    title = {
        display: "none",
    }
}

@registerStyle(DonateHomeEditDonationComponentStyle)
export class DonateHomeEditDonationComponent extends DonateHomeDonateComponent {
    updateDonation() {
        Flow.donation.donationAmount = Flow.donation.getTotalAmount();
        Flow.donation.donatePageUpdateDonation(this.options.changeURL);
    }
}
